import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { first, filter } from "rxjs/operators";
import { Subscription } from "rxjs";
import { AuthService } from "../../core/services/auth.service";
import { MessServiceService, Role } from "@app/shared/common";
import { Store } from "@ngrx/store";

@Component({
  selector: "app-login-page",
  templateUrl: "./login-page.component.html",
  styleUrls: ["./login-page.scss"],
})
export class LoginPageComponent implements OnInit, OnDestroy {
  /**
   * * General
   * @loginForm FormGroup for login
   * @subscriptions Subscriptions array
   */

  loginForm: FormGroup;
  subscriptions: Subscription[] = [];
  errorMessage;
  appConfig;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private messService: MessServiceService,
    private router: Router,
    private store: Store<{ config: any }>
  ) {
    /**
     * Get apiUrl from app config store
     */
    this.subscriptions.push(
      store.select("config").subscribe((res) => {
        this.appConfig = res;
      })
    );
  }

  /* ====================================
  *              LIFECYCLES
  ======================================= */

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      email: [""],
      password: [""],
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.messService.clearErrors();
  }

  /* ====================================
  *             MAIN FEATURES
  ======================================= */

  onSubmit() {
    this.authService.login();

    // this.subscriptions.push(
    //   this.authService
    //     .login(formData)
    //     .pipe(first())
    //     .subscribe({
    //       error: (error: any) => {
    //         this.errorMessage = [
    //           {
    //             severity: 'error',
    //             summary: '',
    //             detail: error.error.message,
    //           },
    //         ];
    //       },
    //     })
    // );
  }
}
